// extracted by mini-css-extract-plugin
export default {"edgePath":"Edge_edgePath__J70oV","selected":"Edge_selected__CTI+X"};